import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';
import {FormattedMessage} from 'react-intl';

import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import FormContext from './FormContext';

class SelectInput extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.generateComponent = this.generateComponent.bind(this);
        this.getOptions = this.getOptions.bind(this);
        this.getText = this.getText.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    generateComponent(props) {
        const {disabled, fullWidth, input, label, messageId, meta: {active, error, touched, warning}, multiple, ...rest} = props;

        return (
            <FormControl
                className="select"
                disabled={disabled}
                fullWidth={fullWidth === undefined ? true : fullWidth}
            >
                <InputLabel htmlFor={rest.field} shrink>
                    {messageId ? <FormattedMessage id={messageId}/> : label}
                </InputLabel>
                <Select
                    inputProps={{name: props.field, id: props.field}}
                    multiple={multiple}
                    onBlur={input.onBlur}
                    onChange={event => input.onChange(event.target.value)}
                    renderValue={selectedItems =>
                        Array.isArray(selectedItems)
                            ? selectedItems.sort().reduce((acc, item, index) => {
                                acc.push(this.getText(item, index));
                                if (index !== selectedItems.length - 1) {
                                    acc.push(<span key={`comma-${index}`}>, </span>);
                                }
                                return acc;
                            }, [])
                            : this.getText(selectedItems)
                    }
                    value={input.value || []}
                    {...rest}
                >
                    {this.getOptions(input, this.props.options, multiple)}
                </Select>
                <FormHelperText error={!!error ? !!error : undefined}>
                    {do {
                        if (touched && !!error) {
                            error;
                        } else if (active && touched && !error && !!warning) {
                            warning;
                        }
                    }}
                </FormHelperText>
            </FormControl>
        );
    }

    getOptions(input, options, multiple) {
        return options.map(option => {
            return (
                <MenuItem
                    disabled={option.disabled}
                    key={option.key}
                    value={option.key}
                >
                    {do {
                        if (multiple) {
                            <Checkbox checked={input.value.indexOf(option.key) > -1}/>;
                        }
                    }}
                    {option.text ? option.text : <FormattedMessage id={option.messageId}/>}
                </MenuItem>
            );
        });
    }

    getText(selectedItem, index) {
        const opt = this.props.options.find(option =>
            option.key === selectedItem);
        if (!!opt && opt.hasOwnProperty('text')) {
            return opt.text;
        } else if (!!opt && opt.hasOwnProperty('messageId')) {
            return <FormattedMessage key={index} id={opt.messageId}/>;
        } else {
            return selectedItem;
        }
    }

    handleKeyDown(e, onKeyDown) {
        if (e.charCode === 13 && !e.shiftKey) {
            return onKeyDown(e);
        } else if (e.charCode === 9) {
            e.stopPropagation();
        }
    }

    render() {
        const {show, ...rest} = this.props;

        if (show !== undefined && !show) {
            return null;
        }

        return (
            <FormContext.Consumer>
                {context => {
                    return (
                        <span className="input">
                            <Field
                                name={rest.field}
                                component={this.generateComponent}
                                onKeyPress={e => this.handleKeyDown(e, context.handleKeyDown)}
                                {...rest}
                            />
                            {this.props.helpButton}
                        </span>
                    );
                }}
            </FormContext.Consumer>
        );
    }
}

SelectInput.propTypes = {
    field: PropTypes.string.isRequired,
    fullWidth: PropTypes.bool,
    helpButton: PropTypes.node,
    label: PropTypes.string,
    messageId: PropTypes.string,
    options: PropTypes.array.isRequired,
    show: PropTypes.bool
};

export default SelectInput;


// WEBPACK FOOTER //
// ./src/components/common/form/SelectInput.js